// extracted by mini-css-extract-plugin
export default {"colorModeToggle":"colorModeToggle_x44X"};